import style from './Object.module.css';

import InfoIcon from 'assets/svg/icon_info-01.svg';
import ModalSelectSample from 'components/Modals/ModalSelectSample/idnex';

import { PUBLIC_ASSETS, address_server_short } from 'config';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import Icon from 'ui/Icon';
import RegularButton from 'ui/RegularButton';
import Tooltip from 'ui/Tooltip';
import FormTextField from 'ui/formItems/FormTextField';

const ExternalObject = ({ object, index }) => {
  const { setValue } = useFormContext();

  const [selectedItems, setSelectedItems] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setValue(`objects.[${index}].id`, object.id);
    setValue(`objects.[${index}].type`, object.type);
    setValue(`objects.[${index}].derived`, object.derived);
    if (object.value !== null) {
      if (object.type === 'type_samples')
        setValue(`objects.[${index}].value.volume`, object?.value?.volume?.amount);
      setValue(`objects.[${index}].value.id`, object?.value?.id);
    }
  }, []);

  const Line = () => {
    return (
      <div
        style={{
          width: '40px',
          height: '40px',
          marginLeft: '22px',
        }}
      >
        <div
          style={{
            borderBottom: '3px solid grey',
            borderLeft: '3px solid grey',
            width: '40px',
            height: '20px',
          }}
        ></div>
      </div>
    );
  };

  const EmptySample = () => {
    return <div className={style.emptyText}>Не выбрано</div>;
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <div className={style.objectExternalContainer}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.5rem',
        }}
      >
        <div
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <div className={style.objectIconContainer}>
            <Icon
              width="44px"
              height="44px"
              src={address_server_short + PUBLIC_ASSETS + (object?.image ?? '')}
            />
            <div>{object?.name}</div>
          </div>
          <div>
            <RegularButton
              text={'Выбрать'}
              variant={'flat'}
              onClick={() => {
                setOpen(true);
              }}
            />
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
          }}
        >
          <Line />
          {selectedItems === null ? (
            <EmptySample />
          ) : (
            <div
              style={{
                display: 'flex',
                gap: '1rem',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <div>ID:{selectedItems?.[0]?.id}</div>
              <div>Штрихкод: {selectedItems?.[0]?.barcode_value ?? 'Нет'}</div>
              <div>
                <Tooltip text={selectedItems?.[0]?.locations?.path?.toString() ?? '1234'}>
                  <Icon src={InfoIcon} />
                </Tooltip>
              </div>
              <div
                style={{
                  display: 'flex',
                  marginLeft: 'auto',
                  marginRight: ' 10px',
                  width: '300px',
                }}
              >
                <FormTextField
                  name={`objects.[${index}].value.volume`}
                  defaultValue={
                    selectedItems?.[0]?.volume?.amount
                      ? Number(selectedItems?.[0]?.volume.amount)
                      : 0
                  }
                  min={0}
                  hideErrorBlock
                  label="Количество:"
                  max={
                    selectedItems?.[0]?.volume?.amount
                      ? Number(selectedItems?.[0]?.volume.amount)
                      : 0
                  }
                  type={'number'}
                  step={0.1}
                />
                <div className={style.objectUnit}>
                  {selectedItems?.[0] && selectedItems?.[0]?.volume?.unit_name}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {open && (
        <ModalSelectSample
          open={open}
          onClose={onClose}
          submit={(props) => {
            setValue(`objects.[${index}].value.id`, props?.[0]?.id);
            setSelectedItems(props);
          }}
          sampleType={object}
        />
      )}

      {/* {object?.type !== 'type_sample_sources' && (
        <>
          <FormTextField
            name={`objects.[${index}].value.volume`}
            defaultValue={
              selectedSourceItem?.volume?.amount ? Number(selectedSourceItem.volume.amount) : 0
            }
            min={0}
            hideErrorBlock
            className={style.objectInput}
            label="Количество:"
            max={selectedSourceItem?.volume?.amount ? Number(selectedSourceItem.volume.amount) : 0}
            type={'number'}
            step={0.1}
          />
          <div className={style.objectUnit}>
            {selectedSourceItem && selectedSourceItem.volume?.unit_name}
          </div>
        </>
      )} */}
    </div>
  );
};

export default ExternalObject;
